import React from 'react';
import '../../Auth/Auth.css';
import { connect } from "react-redux";
import SignupForm from './SignupForm';
import { userSignupRequest } from '../../../redux/actions/signupAction';
import { pageText } from '../../../utils/pageText';

function SignUp(props) {
  return (
    <div className="modern-signin-container">
      {/* 左侧品牌区域 */}
      <div className="signin-brand-section">
        <div className="brand-content">
          <div className="brand-header">
            <div className="brand-logo">
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                <rect width="48" height="48" rx="12" fill="#667eea"/>
                <path d="M16 24L22 30L32 18" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h1 className="brand-title">Kneron MLOPs</h1>
            <p className="brand-subtitle">{pageText("Join our platform to streamline your ML workflow")}</p>
          </div>
          
          <div className="brand-features">
            <div className="feature-card">
              <h3>{pageText("Smart Annotation")}</h3>
              <p>{pageText("Integrated with CVAT and Label Studio, supporting multiple data types annotation")}</p>
            </div>
            <div className="feature-card">
              <h3>{pageText("Model Training")}</h3>
              <p>{pageText("Support training and evaluation of various deep learning models like YOLO, ResNet")}</p>
            </div>
            <div className="feature-card">
              <h3>{pageText("Team Collaboration")}</h3>
              <p>{pageText("Organization-based permission management for team collaboration and data sharing")}</p>
            </div>
          </div>
        </div>
      </div>

      {/* 右侧注册表单区域 */}
      <div className="signin-form-section">
        <div className="form-wrapper">
          <SignupForm signupActions={props.signupActions} />
        </div>
      </div>
    </div>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    signupActions: {
      userSignupRequest: (userData) => dispatch(userSignupRequest(userData))
    }
  };
};

export default connect(null, mapDispatchToProps)(SignUp);
